import React, { useState } from 'react';
import './Roles.css';

const RadioButton = ({ role, data, onSelect }) => {
  const selectHandler = (value) => {
    onSelect(value);
    console.log(value, "This is the value");
  };

  const styles = {
    option: {
      fontSize: 20,
      color: 'rgba(255, 0, 0, 1)',
      textAlign: 'center',
    },
    unselected: {
      color: "#fff",
      backgroundColor: "#013469",
      fontSize: 20,
      borderRadius: 10,
      textAlign: "center",
      marginLeft: 10,
      marginRight: 10,
      padding: "8px",
      cursor: "pointer"
    },
    selected: {
      color: "#fff",
      backgroundColor: "rgba(255, 0, 0, 1)",
      fontSize: 20,
      borderRadius: 10,
      textAlign: "center",
      marginLeft: 10,
      marginRight: 10,
      padding: "8px",
      cursor: "pointer"
    },
  };

  return (
    <div>
      {data.map((item) => {
        return (
          <div key={item.value} className="radio-item">
            <div
              style={item.value === role ? styles.selected : styles.unselected}
              onClick={() => selectHandler(item.value)}>
              {item.value}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RadioButton;